// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useStaffRoles() {
  return useQuery({
    queryKey: ["staff-roles"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_staff_roles")
        .select("*")
        .order("name");
      if (error) throw error;
      return data;
    },
  });
}

export function useEventStaffNeeds(eventId: string | null) {
  return useQuery({
    queryKey: ["event-staff-needs", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_event_staff_needs")
        .select("*, role:manage_staff_roles(*)")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useStaffAssignments(eventId: string | null) {
  return useQuery({
    queryKey: ["staff-assignments", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_staff_event_assignments")
        .select("*, role:manage_staff_roles(*), staff:event_staff(*)")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useEventStaff() {
  return useQuery({
    queryKey: ["event-staff-directory"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("event_staff")
        .select("*")
        .order("name");
      if (error) throw error;
      return data;
    },
  });
}

export function useUpcomingEventsForStaffing() {
  return useQuery({
    queryKey: ["upcoming-events-for-staffing"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("events")
        .select("id, name, start_date, end_date, venue_id, venue_name, venue_city, additional_venue_ids")
        .gte("end_date", new Date().toISOString().split("T")[0])
        .order("start_date");
      if (error) throw error;
      return data;
    },
  });
}

export function useVenues(venueIds: string[]) {
  return useQuery({
    queryKey: ["venues-for-staffing", venueIds],
    enabled: venueIds.length > 0,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("venues")
        .select("id, name, city, state")
        .in("id", venueIds);
      if (error) throw error;
      return data;
    },
  });
}
